import { SubmissionStatusLine } from 'Components/lines/submission-status-line/SubmissionStatusLine';
export default SubmissionStatusLine;
